import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

export const HeaderContainer = styled(Box)(({ theme }) => ({
  width: '100%',
  padding: theme.spacing(1.5),
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  boxSizing: 'border-box',
  backgroundColor: theme.palette.fog[95],
  borderBottom: `1px solid ${theme.palette.fog[85]}`,
  position: 'sticky',
  top: 0,
  left: 0,
  zIndex: 11,

  gap: 16,

  // [theme.breakpoints.up('md')]: {
  //   gap: 24,
  // },

  [theme.breakpoints.up('sm')]: {
    position: 'relative',
  },

  [theme.breakpoints.up('md')]: {
    gap: 24,
    backgroundColor: 'transparent',
    padding: theme.spacing(3),
    border: 0,
  },
}));

type PlanBadgeProps = {
  plan: 'trial' | 'free' | 'pro';
};

export const PlanBadge = styled(Box)<PlanBadgeProps>(({ theme, plan }) => ({
  padding: '3px 12px',
  borderRadius: theme.shape.borderRadius,

  ...(plan === 'trial' && {
    backgroundColor: theme.palette.lime[100],
    color: theme.palette.lime[150],
  }),

  ...(plan === 'free' && {
    backgroundColor: theme.palette.lime[100],
    color: theme.palette.lime[150],
  }),

  ...(plan === 'pro' && {
    backgroundColor: theme.palette.violet[100],
    color: theme.palette.neutral[100],
  }),

  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
}));
